export var version = '3.8.0';
//# sourceMappingURL=version.js.map